import React from 'react';
import './BottomSheet2.css';

const BottomSheet2 = ({ open, children, onClose }) => {
  // Close BottomSheet when clicking outside content
  const handleClickOutside = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div
      className={`bottom-sheet-overlay ${open ? 'open' : ''}`}
      onClick={handleClickOutside}
    >
      <div className="bottom-sheet-content" onClick={(e) => e.stopPropagation()}>
        <button
          className="bottom-sheet-close"
          style={{ fontSize: '16px' }}
          onClick={onClose}
        >
          Close
        </button>
        {children}
      </div>
    </div>
  );
};

export default BottomSheet2;
